import React from 'react';


function EmailInfo() {
  return (
    <div className="notify">
      <p>
        <strong>Note:</strong> Email clients
        may block or divert our replies to
        you because the word &apos;Naked&apos; sets
        off their spam detectors. To resolve
        any issues, please visit our&nbsp;
        <a href="/faq">FAQ page</a> or email
        us at&nbsp;
        <a href="mailto:support@nakednews.com">
          support@nakednews.com
        </a>
      </p>
    </div>
  );
}

export default EmailInfo;
